import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router preserves scroll position between route changes by default.
// This component scrolls the window back to the top whenever the pathname
// changes (hash navigation is left untouched so in-page anchors still work).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let the browser handle #anchor jumps
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
